import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import selects from 'scoreboard/components/selects'
import Dataset from 'scoreboard/datasets/model/dataset'
const { BLANK } = Dataset

/**
 * Renders a tag-style select appropriate for yes-no filters.
 *
 * @param {HTMLSelectElement} el the <select> element to enhance
 *
 * @param {Object} opt
 *
 * @param {Array} [opt.selected] list of values that should be pre-selected
 *
 * @param {boolean} [opt.open=false] true if the dropdown should be open immediately
 * after rendering
 *
 * @param {Boolean} [opt.includeBlank=true] true if the blank option should be
 * included
 */
function renderYesNoSelect (el, opt = {}) {
	function render (val) {
		// Adding a CSS class so that the labels can be capitalized by css
		return `<span class="yes-no-value">${val.label}</span>`
	}

	// Merge the provided options with the default includeBlank option.
	// Does not override includeBlank if it is already set
	opt = Object.assign({ includeBlank: true }, opt)
	let potentialValues = ['yes', 'no']
	if (opt.includeBlank) {
		potentialValues.push(BLANK)
	}

	const selected = _.map(opt.selected, value => value.toLowerCase())
	selects(el, {
		multiple: true,
		open: opt.open,
		options: potentialValues.map(value => {
			return {
				value,
				label: i18n.get('common.' + (value === BLANK ? 'blank' : value)),
				selected: _.includes(selected, value)
			}
		}),
		render: {
			option: render,
			item: render
		}
	})
}

export default renderYesNoSelect

renderYesNoSelect.__filename__ = 'datasets/filters/render-yes-no-select.js'
